<!-- RICERCA GENERALE -->
<ng-container *ngIf="block && block.bundle !== 'blocco_corsi_di_laurea_tutti_'">
    <div *ngIf="filtersNoDefault && filtersNoDefault.length" class="container-select-course"
    [ngClass]="block.bundle === 'blocco_tutti_gli_eventi' || block.bundle === 'blocco_tutte_le_news' || block.bundle === 'blocco_tutti_gli_avvisi' ? 'bg-neutral-95': 'bg-brand-99'"
    [ngStyle]="{'border-bottom': block.bundle === 'blocco_tutti_gli_eventi' || block.bundle === 'blocco_tutte_le_news' || block.bundle === 'blocco_tutti_gli_avvisi' ? '1px solid #CCD1CF' : ''}">
    <div class="container">
        <div [ngClass]="filtersNoDefault.length >= 3 ? 'col-12' : 'col-8 m-auto'">
            <div class="container-select-course__title">
                <h2 *ngIf="block.titolo" class="ls-h2-section-title text-brand-10" [innerText]="block.titolo"></h2>
                <h2 *ngIf="block.sottotitolo" class="ls-p text-neutral-40" [innerText]="block.sottotitolo"></h2>
                <p *ngIf="!block.titolo && !block.sottotitolo"
                    class="text-brand-10 ls-label-medium-semibold text-uppercase">
                    {{"BLOCK.VIEW_SELECT_FILTERS.FILTER_CONTENTS" | translate}}</p>
            </div>
            <ng-container *ngIf="block.bundle !== 'blocco_corsi_di_laurea_ricerca_' && block.bundle !== 'blocco_corsi_di_laurea_tutti_'">
                <div class="container-select-course__container-filter__box-item mb-5 position-relative"
                    *ngFor="let item of filtersInputText; let idx = index;">
                    <app-input-text-filter *ngIf="item.filter_type === 'text' || item.filter_type === 'Text'" [block]="item" class="position-relative"
                        [resetValue]="resetValueCheckbox" (onTyped)="item.value_sel = $event; setVariable();" 
                        [firstInput]="idx === 0" [lastInput]="idx === filtersInputText.length - 1">
                    </app-input-text-filter>
                    <img loading="lazy" *ngIf="item.filter_type === 'text' || item.filter_type === 'Text'" class="search-icon cursor-pointer" 
                    (click)="event='click';search()"
                        src="../../../../../assets/images/search.png" alt="search-icon">
                </div>
            </ng-container>
            <div
                class="container-select-course__container-filter d-flex flex-wrap flex-lg-nowrap justify-content-center align-items-center">
                <div class="container-select-course__container-filter__box-item {{ colString }}"
                    *ngFor="let item of filtersNoInputText; let idx = index;">
                    <app-multiple-select *ngIf="item.filter_type === 'vocabulary[]'" [block]="item"
                        (onSelected)="item.value_sel = $event;setVariable();"
                        [resetValueCheckbox]="resetValueCheckbox" [id]="idx"
                        [positionBlock]="{actualPosition: idx, lastOfIndex: filtersNoDefault.length - 1}"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1">
                    </app-multiple-select>
                    <app-multiple-select *ngIf="item.filter_type === 'textList[]'" [block]="item"
                        (onSelected)="item.value_sel = $event;setVariable();"
                        [resetValueCheckbox]="resetValueCheckbox" [id]="idx"
                        [positionBlock]="{actualPosition: idx, lastOfIndex: filtersNoDefault.length - 1}"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1">
                    </app-multiple-select>
                    <app-text-list *ngIf="item.filter_type === 'textList'" [block]="item"
                        [resetValue]="resetValueCheckbox"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1"
                        (onSelected)="item.value_sel = $event; setVariable();"></app-text-list>
                    <app-text-list *ngIf="item.filter_type === 'vocabulary'" [block]="item"
                        [resetValue]="resetValueCheckbox"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1"
                        (onSelected)="item.value_sel = $event; setVariable();"></app-text-list>
                    <app-input-text-filter *ngIf="item.filter_type === 'text'" [block]="item"
                        [resetValue]="resetValueCheckbox"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1"
                        (onTyped)="item.value_sel = $event; setVariable();"></app-input-text-filter>
                    <app-input-date-filter *ngIf="item.filter_type === 'date'" [block]="item"
                        (onTyped)="item.value_sel = $event; setVariable();"
                        [resetValue]="resetValueCheckbox"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1"></app-input-date-filter>
                </div>
            </div>
            <div class="container-select-course__cta position-relative d-flex justify-content-center align-items-center">
                <button *ngIf="block.label_link" 
                    [disabled]="!isViewReset"
                    class="btn ls-label-medium-semibold text-uppercase"
                    [ngClass]="isViewReset ? 'btn-custom-active' : 'btn-custom-disable'"
                    (click)="block.link_a_pagina_risultati ? search('', true, block.link_a_pagina_risultati.url) : search()"
                    [innerHTML]="block.label_link">
                </button>
                <button *ngIf="!block.label_link" 
                    [disabled]="!isViewReset"
                    class="btn ls-label-medium-semibold text-uppercase"
                    [ngClass]="isViewReset ? 'btn-custom-active' : 'btn-custom-disable'"
                    (click)="event = 'click';search()">{{"BLOCK.VIEW_SELECT_FILTERS.FILTER" | translate}}</button>
                <div *ngIf="isViewReset" class="cursor-pointer position-absolute container-select-course__cta__container-reset-btn" (click)="resetValue()">
                    <p class="ls-label-small-semibold text-uppercase text-brand-40 m-0">
                        {{"BLOCK.VIEW_SELECT_FILTERS.RESET" | translate}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
</ng-container>
<!-- END RICERCA GENERALE -->
<!-- RICERCA CORSI -->
<ng-container *ngIf="block && block.bundle === 'blocco_corsi_di_laurea_tutti_'">
    <div *ngIf="filtersNoDefault && filtersNoDefault.length" class="container-select-course"
    [ngClass]="block.bundle === 'blocco_tutti_gli_eventi' || block.bundle === 'blocco_tutte_le_news' || block.bundle === 'blocco_tutti_gli_avvisi' ? 'bg-neutral-95': 'bg-brand-99'"
    [ngStyle]="{'border-bottom': block.bundle === 'blocco_tutti_gli_eventi' || block.bundle === 'blocco_tutte_le_news' || block.bundle === 'blocco_tutti_gli_avvisi' ? '1px solid #CCD1CF' : ''}">
    <div class="container">
        <div [ngClass]="filtersNoDefault.length >= 3 ? 'col-12' : 'col-8 m-auto'">
            <div class="container-select-course__title">
                <h2 *ngIf="block.titolo" class="ls-h2-section-title text-brand-10" [innerText]="block.titolo"></h2>
                <h2 *ngIf="block.sottotitolo" class="ls-p text-neutral-40" [innerText]="block.sottotitolo"></h2>
                <p *ngIf="!block.titolo && !block.sottotitolo"
                    class="text-brand-10 ls-label-medium-semibold text-uppercase">
                    {{"BLOCK.VIEW_SELECT_FILTERS.FILTER_CONTENTS" | translate}}</p>
            </div>
            <ng-container *ngIf="block.bundle !== 'blocco_corsi_di_laurea_ricerca_' && block.bundle !== 'blocco_corsi_di_laurea_tutti_'">
                <div class="container-select-course__container-filter__box-item mb-5 position-relative"
                    *ngFor="let item of filtersInputText; let idx = index;">
                    <app-input-text-filter *ngIf="item.filter_type === 'text'" [block]="item" class="position-relative"
                        [resetValue]="resetValueCheckbox" (onTyped)="item.value_sel = $event; setVariable();" [firstInput]="idx === 0" [lastInput]="idx === filtersInputText.length - 1">
                    </app-input-text-filter>
                    <img loading="lazy" *ngIf="item.filter_type === 'text'" class="search-icon cursor-pointer" (click)="event='click';search()"
                        src="../../../../../assets/images/search.png" alt="search-icon">
                </div>
            </ng-container>
            <div
                class="container-select-course__container-filter d-flex flex-wrap justify-content-center align-items-stretch"
                [ngClass]="{'gap-custom': block.bundle === 'blocco_corsi_di_laurea_tutti_' && !changeViewFilters}">
                <ng-container *ngIf="filtersNoInputText && filtersNoInputText.length">
                    <div class="container-select-course__container-filter__box-item {{ colString }}" 
                    [ngClass]="changeViewFilters ? 'flex-lg-nowrap' : 'flex-lg-wrap'" style="height: 70px;"
                    *ngFor="let item of filtersNoInputText; let idx = index;">
                    <app-multiple-select *ngIf="item && item.filter_type === 'vocabulary[]'" [block]="item"
                        (onSelected)="item.value_sel = $event;setVariable();"
                        [resetValueCheckbox]="resetValueCheckbox" [id]="idx" [isCorsiLaureaTutti]="item.filter_name === 'keyword_tematiche' || item.filter_name === 'profili_professionali'"
                        [positionBlock]="{actualPosition: idx, lastOfIndex: filtersNoDefault.length - 1}"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1">
                    </app-multiple-select>
                    <app-multiple-select *ngIf="item && item.filter_type === 'textList[]'" [block]="item"
                        (onSelected)="item.value_sel = $event;setVariable();"
                        [resetValueCheckbox]="resetValueCheckbox" [id]="idx"
                        [positionBlock]="{actualPosition: idx, lastOfIndex: filtersNoDefault.length - 1}"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1">
                    </app-multiple-select>
                    <app-text-list *ngIf="item && item.filter_type === 'textList'" [block]="item"
                        [resetValue]="resetValueCheckbox"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1"
                        (onSelected)="item.value_sel = $event; setVariable();"></app-text-list>
                    <app-text-list *ngIf="item && item.filter_type === 'vocabulary'" [block]="item"
                        [resetValue]="resetValueCheckbox"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1"
                        (onSelected)="item.value_sel = $event; setVariable();"></app-text-list>
                    <app-input-text-filter *ngIf="item && item.filter_type === 'text'" [block]="item"
                        [resetValue]="resetValueCheckbox"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1"
                        (onTyped)="item.value_sel = $event; setVariable();"></app-input-text-filter>
                    <app-input-date-filter *ngIf="item && item.filter_type === 'date'" [block]="item"
                        (onTyped)="item.value_sel = $event; setVariable();"
                        [resetValue]="resetValueCheckbox"
                        [firstInput]="idx === 0" [lastInput]="idx === filtersNoInputText.length - 1"></app-input-date-filter>
                </div>
                </ng-container>
            </div>
            <div class="container-select-course__cta position-relative d-flex justify-content-center align-items-center">
                <button *ngIf="block.label_link" 
                    class="btn ls-label-medium-semibold text-uppercase"
                    [ngClass]="isViewReset ? 'btn-custom-active' : 'btn-custom-disable'"
                    [disabled]="!isViewReset"
                    (click)="block.link_a_pagina_risultati ? search('', true, block.link_a_pagina_risultati.url) : search()"
                    [innerHTML]="block.label_link"></button>
                <button *ngIf="!block.label_link" 
                    class="btn ls-label-medium-semibold text-uppercase"
                    [ngClass]="isViewReset ? 'btn-custom-active' : 'btn-custom-disable'"
                    [disabled]="!isViewReset"
                    (click)="event='click';search()">
                    {{"BLOCK.VIEW_SELECT_FILTERS.SEARCH_COURSE" | translate}}
                </button>
                <div *ngIf="isViewReset" class="cursor-pointer position-absolute container-select-course__cta__container-reset-btn" (click)="resetValue()">
                    <p class="ls-label-small-semibold text-uppercase text-brand-40 m-0">
                        {{"BLOCK.VIEW_SELECT_FILTERS.RESET" | translate}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
</ng-container>